"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _constants = require("../../../../constants");
const SearchMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "22px",
  height: "22px",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("path", {
  d: "M10,1.5 C14.6944204,1.5 18.5,5.30557963 18.5,10 C18.5,12.1675829 17.6886499,14.1456648 16.3530798,15.6471157 L22.7071068,22 L22,22.7071068 L15.6461135,16.3539711 C14.1447847,17.6890109 12.1671007,18.5 10,18.5 C5.30557963,18.5 1.5,14.6944204 1.5,10 C1.5,5.30557963 5.30557963,1.5 10,1.5 Z M10,2.5 C5.85786438,2.5 2.5,5.85786438 2.5,10 C2.5,14.1421356 5.85786438,17.5 10,17.5 C14.1421356,17.5 17.5,14.1421356 17.5,10 C17.5,5.85786438 14.1421356,2.5 10,2.5 Z"
}));
const SearchPrizm = ({
  fill
}) => _react.default.createElement("svg", {
  width: "32px",
  height: "32px",
  viewBox: "0 0 32 32",
  fill: fill
}, _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("g", {
  transform: "translate(5.000000, 5.000000)"
}, _react.default.createElement("path", {
  d: "M21.7,20.3 L17.7,16.3 C19.1,14.6 20,12.4 20,10 C20,4.5 15.5,0 10,0 C4.5,0 0,4.5 0,10 C0,15.5 4.5,20 10,20 C12.4,20 14.6,19.2 16.3,17.7 L20.3,21.7 C20.5,21.9 20.8,22 21,22 C21.2,22 21.5,21.9 21.7,21.7 C22.1,21.3 22.1,20.7 21.7,20.3 L21.7,20.3 Z M10,18 C5.6,18 2,14.4 2,10 C2,5.6 5.6,2 10,2 C14.4,2 18,5.6 18,10 C18,14.4 14.4,18 10,18 L10,18 Z"
}))));
const Search = ({
  theme,
  fill = '#fff',
  ...other
}) => theme.name === _constants.THEMES.mds ? _react.default.createElement(SearchMDS, (0, _extends2.default)({
  fill: fill
}, other)) : _react.default.createElement(SearchPrizm, (0, _extends2.default)({
  fill: fill
}, other));
var _default = exports.default = (0, _styledComponents.withTheme)(Search);